import React, { useEffect, useState, useCallback } from 'react';
import { isEmpty } from '../../lib/utils';
import ConsoleLog from '../../common/ConsoleLog';
import PropTypes from 'prop-types';

const AnswerChoices = ({
    questionObj = {},
    selectedAnswer,
    onAnswerGiven,
    conditionEvaluations = {},
    product,
    options
}) => {
    const [visibleOptions, setVisibleOptions] = useState([]);
    let defaultBlank = null;
    // Add debug logging
    //useEffect(() => {
        //console.group(`AnswerChoices Debug: ${questionObj?.question?.variable}`);
        //console.log('questionObj:', {
        //    variable: questionObj?.question?.variable,
        //    isDropDown: questionObj?.isDropDown,
        //    options: questionObj?.options,
        //    visibleOptions: visibleOptions
       // });
        //console.log('selectedAnswer:', selectedAnswer);
        //console.log('conditionEvaluations:', conditionEvaluations);
        //console.groupEnd();
  //  }, [questionObj, selectedAnswer, conditionEvaluations, visibleOptions]);

    // Update visible options when conditions or options change
    useEffect(() => {
        if (!questionObj?.options) {
            setVisibleOptions([]);
            return;
        }
        
        let newVisibleOptions = [];

        if (questionObj.constrainedOptions2 && questionObj.constrainedOptions2.length > 0) {
        // Filter constrained options based on conditions
 /*       newVisibleOptions = questionObj.constrainedOptions2.filter(option => 
            !option.conditions || 
            option.conditions.length === 0 || 
            (!isEmpty(option.conditionName) && 
             conditionEvaluations[option.conditionName] === true)
        );
        */
   
            for (const constraintGroup of questionObj.constrainedOptions2) {
                // Check if all conditions are met using conditionEvaluations
                const conditionsMet = constraintGroup.conditions.every(condition => {
                    // Use conditionEvaluations to check if the condition is true
                    return conditionEvaluations[condition.conditionName] === true;
                });
            
                if (conditionsMet) {
                    // If conditions are met, assign the options to newVisibleOptions
                    newVisibleOptions = constraintGroup.options;
                    break; // Exit the loop after finding the first valid set of options
                }
            }
        }
    
    // If no valid constrained options were found, fall back to regular options
        if (newVisibleOptions.length === 0 && questionObj.options) {
            newVisibleOptions = questionObj.options.filter(option => 
                !option.conditions || 
                option.conditions.length === 0 || 
                (!isEmpty(option.conditionName) && 
                conditionEvaluations[option.conditionName] === true)
            );
        }
        setVisibleOptions(newVisibleOptions);
        if (!selectedAnswer && newVisibleOptions.length > 1 && questionObj.question?.variable) {
           
            const defaultOption = newVisibleOptions.find(opt => opt.isDefault);
            if (defaultOption) {
                onAnswerGiven(questionObj.question.variable, defaultOption.optionValue);
            }
        }
        // If there's only one option and no answer selected yet, select it automatically
        else if (newVisibleOptions.length === 1 && !selectedAnswer && questionObj.question?.variable) {
            debugger;
            onAnswerGiven(questionObj.question.variable, newVisibleOptions[0].optionValue);
        }
        // If there's a selected answer that's not in visible options, replace it
        else if (selectedAnswer && 
            newVisibleOptions.length > 0 && 
            !newVisibleOptions.some(opt => opt.optionValue === selectedAnswer)) {
            const defaultOption =
                newVisibleOptions.find(opt => opt.isDefault) ||
                (newVisibleOptions.length === 1 ? newVisibleOptions[0] : null) ||
                newVisibleOptions[0];
            if (defaultOption) {
                onAnswerGiven(questionObj.question.variable, defaultOption.optionValue);
            }
        }
    }, [
        questionObj?.options,
        questionObj?.constrainedOptions,
        conditionEvaluations,
        questionObj?.question?.variable,
        onAnswerGiven,
        selectedAnswer
    ]);

    const handleAnswerChange = useCallback((event) => {
        if (questionObj.question?.variable) {
            const value = event.target.value;
            const valueType = questionObj.question?.valueType;
            const valueLength = questionObj.question?.valueLength;
            const valueDecimals = questionObj.question?.valueDecimals;
            
            let isValid = true;
            let processedValue = value;
            
            // Validate input based on question restrictions
            if (valueType === 'C' && valueLength) {
                // Character type - limit length
                if (value.length > valueLength) {
                    isValid = false;
                }
            } else if (valueType === 'N') {
                // Number type validation
                if (value === '' || value === '-') {
                    // Allow empty or minus sign for negative numbers
                    isValid = true;
                } else {
                    const numValue = parseFloat(value);
                    if (isNaN(numValue)) {
                        isValid = false;
                    } else {
                        // Check decimal places
                        if (valueDecimals !== undefined) {
                            const decimalPlaces = (value.split('.')[1] || '').length;
                            if (decimalPlaces > valueDecimals) {
                                isValid = false;
                            }
                        }
                        
                        // Check total digits before decimal
                        if (valueLength) {
                            const integerPart = value.split('.')[0];
                            if (integerPart.length > valueLength) {
                                isValid = false;
                            }
                        }
                    }
                }
            }
            
            // Only update if validation passes
            if (isValid) {
                onAnswerGiven(questionObj.question.variable, value);
            }
        }
    }, [questionObj.question, onAnswerGiven]);

    // Guard against undefined in render
    if (!questionObj?.options || !product?.productId) {
        return null;
    }

    // Debug render logic
    const renderInputType = () => {
     /*
        console.log(`Rendering input for ${questionObj?.question?.variable}:`, {
            isDropDown: questionObj?.isDropDown,
            optionsCount: visibleOptions?.length
        });
*/
        if (questionObj?.isDropDown) {
            const uniqueOptions = [];
            const uniqueKeys = new Set();
            visibleOptions.forEach(option => {
                // Create a unique key based on both optionText and optionValue
                const uniqueKey = `${option.optionValue}|${option.optionText}`;
                
                // Only add this option if we haven't seen this combination before
                if (!uniqueKeys.has(uniqueKey)) {
                    uniqueKeys.add(uniqueKey);
                    uniqueOptions.push(option);
                }
            });
            // If only one option, show disabled, read-only input instead of a select
            if (uniqueOptions.length === 1) {
                const matchedOption = uniqueOptions.find(o => o.optionValue === selectedAnswer);
                const displayText = matchedOption
                    ? matchedOption.optionText
                    : (uniqueOptions[0]?.optionText || selectedAnswer || '');
                return (
                    <input
                        type="text"
                        className="custom-select disabled"
                        value={displayText}
                        readOnly
                        disabled
                        style={{ width: '100%' }}
                    />
                );
            }

            return (
                <select
                    className="custom-select"
                    value={selectedAnswer || ''}
                    onChange={handleAnswerChange}
                >
                    <option value="">Select an option</option>
                    {uniqueOptions.map((option) => (
                        <option
                            key={`${option.optionValue}_${option.optionText}`}
                            value={option.optionValue}
                        >
                            {option.optionText}
                        </option>
                    ))}
                </select>
            );
        } else {
            // Determine input type and restrictions based on question properties
            const valueType = questionObj.question?.valueType;
            const valueLength = questionObj.question?.valueLength;
            const valueDecimals = questionObj.question?.valueDecimals;
            
            let inputType = 'text';
            let maxLength = undefined;
            let pattern = undefined;
            let step = undefined;
            
            if (valueType === 'C' && valueLength) {
                // Character type with length restriction
                maxLength = valueLength;
                defaultBlank = '';
            } else if (valueType === 'N') {
                // Number type
                inputType = 'number';
                defaultBlank = 0.00;
                if (valueLength && valueDecimals !== undefined) {
                    // Calculate max value based on length and decimals
                    const maxValue = Math.pow(10, valueLength) - (1 / Math.pow(10, valueDecimals));
                    pattern = `^\\d{1,${valueLength}}(\\.\\d{1,${valueDecimals}})?$`;
                    step = `0.${'0'.repeat(valueDecimals - 1)}1`;
                } else if (valueLength) {
                    // Integer number with length restriction
                    const maxValue = Math.pow(10, valueLength) - 1;
                    pattern = `^\\d{1,${valueLength}}$`;
                }
                 
            }
            
            return (
                <input id={questionObj.question.variable}
                    type={inputType}
                    className="custom-select"
                    value={selectedAnswer || ''}
                    onChange={handleAnswerChange}
                    maxLength={maxLength}
                    pattern={pattern}
                    step={step}
                />
            );
        }
    };

    return (
        <div>
            {renderInputType()}
        </div>
    );
};

AnswerChoices.propTypes = {
    questionObj: PropTypes.shape({
        options: PropTypes.array,
        question: PropTypes.shape({
            variable: PropTypes.string,
            valueType: PropTypes.oneOf(['C', 'N']),
            valueLength: PropTypes.number,
            valueDecimals: PropTypes.number
        })
    }),
    selectedAnswer: PropTypes.string,
    onAnswerGiven: PropTypes.func.isRequired,
    conditionEvaluations: PropTypes.object,
    product: PropTypes.shape({
        productId: PropTypes.string.isRequired
    }).isRequired
};

 
export default AnswerChoices;
